<button class="btn btn-primary float-left d-none" type="button" (click)="openAddCompany(adduser);"><i class="fa fa-plus"></i> Add User To Company</button>
<button class="btn btn-primary float-left" type="button" [routerLink]="['/account/create', companyId]"><i class="fa fa-plus"></i> Add User To Company</button>

<ng-template #adduser let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Add User To Company</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<form [formGroup]="userAddForm">
		<div class="modal-body">
			<error-message [errors]="errors"></error-message>

			<div class="row form-group">
				<div class="col-md-9">
					<div class="form-group">
						<label class="col-form-label">Users</label>
						<select class="js-example-basic-single form-control" name="siteUserId" formControlName="siteUserId" placeholder="Select an existing user" appSelect2>
							<option *ngFor="let user of users" [value]="user.id">{{ user.firstName + ' ' + user.lastName }}</option>
						</select>
						<span class="text-info">Search first or last name to see if a user already exists, or create a new user.</span>
					</div>
				</div>
				<div class="col-md-3">
					<label class="col-form-label">Or</label>
					<button class="btn btn-info btn-block" type="button" (click)="modal.close('Close');" [routerLink]="['/account/create', companyId]">Add New User</button>
				</div>
			</div>

			<div class="row form-group">
				<div class="col-md-6">
					<div class="form-group">
						<label class="col-form-label">User Type</label>
						<select name="userTypeId" class="form-control" formControlName="userTypeId">
							<option *ngFor="let userType of userTypes" [value]="userType.id">{{ userType.description}}</option>
						</select>
					</div>
				</div>
			</div>

		</div>

		<div class="modal-footer">
			<div class="row">
				<div class="col-md-12 text-right">
					<button type="button" class="btn btn-danger modal-dismiss mr-1" (click)="modal.close('Close');">Cancel</button>
					<button type="button" class="btn btn-success modal-dismiss" (click)="addUserToCompany();" [disabled]="submitAttempt||!userAddForm.valid">Ok</button>
				</div>
			</div>
		</div>
	</form>
</ng-template>

